import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = new HttpLink({
  uri: "https://api.doomo.dev/p_gql",
  options: {
    cache: new InMemoryCache(),
  },
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token =
    "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiZjk4NzAwNmEtZmZhZC00ZTA5LTkzODUtNTA3NzI4NjI5YzE5IiwibG9naW5fYXR0ZW1wdF9pZCI6ImRiYWVmZTNiLTQ4ZDUtNGJlMi1iYjc4LWE2N2Y4NjNhMDYzNiJ9.I4KiVGgi8zHd6BHcnYAL4r3rcq3wOe9WieiEo4Py5RM";
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App client={client} />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
